import React from "react";
import { Navigate } from "react-router-dom";
import { GetSocialLoginToken, getToken } from "./LocalStorage";
import { useSelector } from "react-redux";

const RequireAuth = ({ children, Path }) => {
  // Redux Data
  const ReduxData = useSelector((state) => state);

  const CheckChargebeeSubscriptionFlag =
    ReduxData.CheckChargebee.CheckChargebeeSubscription;

  const Token = getToken();
  const SlToken = GetSocialLoginToken();

  if (!Token && !SlToken) {
    return <Navigate to={"/"} />;
  } else if (CheckChargebeeSubscriptionFlag === true) {
    if (
      Path === "/my-profile/subscription" ||
      Path === "/my-profile/subscription/tier-details" ||
      Path === "/my-profile/subscription/checkOutPage" ||
      Path === "/my-profile/add-card" ||
      Path === "/my-profile/transaction-failed" ||
      Path === "/my-profile/transaction-successful"
    ) {
      return children;
    } else {
      return <Navigate to={"/my-profile/subscription"} />;
    }
  } else {
    return children;
  }
};

export default RequireAuth;
